<template>
  <div id="app">
    <router-view />
    
  </div>
</template>
<script>


export default {
  name: "App",

  data() {
    return {
      isShow: true
    };
  },
  watch: {

  },
  computed: {

  },
  provide() {

  },
  methods: {
    

  }
}
</script>

<style lang="less">
@import url("~assets/css/css.css");

.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
</style>
